import { until } from "@vueuse/core";
import { computed, watch } from "vue";
import { BaseLinkedEntitiesManager } from "../mystekz-linked-entities/manager";
import { DomainEntity } from ".";
import { useWorktreeManager } from "@/composables/worktree-manager";

/**
 * Manages the business entities and replaces
 */
export class DomainsManager extends BaseLinkedEntitiesManager<DomainEntity> {
    nodeType = "domain" as const;
    worktreeManager = useWorktreeManager();

    constructor(baseUrl: string) {
        super(baseUrl);
        const isLoading = computed(() => {
            return (
                this.worktreeManager.isFetching.value ||
                this.organizationManager.isLoadingOrganizations.value ||
                this.stekManager.isLoadingSteks.value
            );
        });
        this.ready = until(isLoading).not.toBeTruthy();

        watch(
            this.worktreeManager.worktree,
            (newWorktree) => {
                if (newWorktree) {
                    this.setEntities(newWorktree.domains);
                }
            },
            { immediate: true }
        );
    }
}
